import { defineCustomElements as defineTegelElements } from '@scania/tegel-react';

export const defineCustomElements = (window: Window): void => {
  const defineElements: (window: Window) => void | Promise<void> = defineTegelElements;
  void defineElements(window);
};
